import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  ScrollView,
  StyleSheet,
  View,
  Text,
  TouchableHighlight,
} from './base_components';

const styles = StyleSheet.create({
  tabBar: {
    alignSelf: 'stretch',
    height: '5rem',
    borderBottomWidth: 1,
    borderBottomColor: '#aaa',
  },
  scroller: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    flexDirection: 'row',
  },
  scrollerInner: {
    alignSelf: 'stretch',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  tab: {
    alignSelf: 'stretch',
    flexDirection: 'row',
  },
  highlight: {
    alignSelf: 'stretch',
    flexDirection: 'column',
  },
  tabInner: {
    flex: 1,
    alignSelf: 'stretch',
    flexDirection: 'column',
  },
  textView: {
    paddingLeft: '2rem',
    paddingRight: '2rem',
    flex: 1,
    alignSelf: 'stretch',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    color: 'var(--sidebar-text-color)',
    fontSize: '1.4rem',
    fontWeight: '600',
  },
  selectedText: {
    color: 'var(--link-text-color)',
    fontWeight: '600',
  },
  line: {
    alignSelf: 'stretch',
    height: 2,
  },
  selectedLine: {
    backgroundColor: 'black',
  },
  sep: {
    marginTop: '1rem',
    marginBottom: '1rem',
    alignSelf: 'stretch',
    width: 1,
    backgroundColor: '#aaa',
  },
});
type Props = {
  style?: any;
  value?: string;
  list: any[];
  onChange?: (value: string) => void;
};
export default function TabBar(props: Props) {
  const { style, value, list, onChange } = props;
  const location = useLocation();
  return (
    <View style={[styles.tabBar, style]}>
      <ScrollView
        style={styles.scroller}
        contentContainerStyle={styles.scrollerInner}
        horizontal={true}
      >
        {list.map((item, i) => {
          const selected =
            item.value === value || item.url === location.pathname;
          return (
            <Tab
              key={i}
              text={item.text}
              value={item.value}
              url={item.url}
              last={i === list.length - 1}
              selected={selected}
              onChange={onChange}
            />
          );
        })}
      </ScrollView>
    </View>
  );
}
function Tab(props: any) {
  const { text, value, url, last, selected, onChange } = props;
  const navigate = useNavigate();

  function _onPress() {
    if (onChange) {
      onChange(value);
    } else {
      navigate(url);
    }
  }
  return (
    <View style={styles.tab}>
      <TouchableHighlight
        style={styles.highlight}
        underlayColor='rgba(0,0,0,0.1)'
        onPress={_onPress}
      >
        <View style={styles.tabInner}>
          <View style={styles.textView}>
            <Text style={[styles.text, selected ? styles.selectedText : null]}>
              {text}
            </Text>
          </View>
          <View style={[styles.line, selected ? styles.selectedLine : null]} />
        </View>
      </TouchableHighlight>
      {last ? null : <View style={styles.sep} />}
    </View>
  );
}
